import { render, staticRenderFns } from "./SubpoenasHeader.vue?vue&type=template&id=dd268c1c&"
import script from "./SubpoenasHeader.vue?vue&type=script&lang=js&"
export * from "./SubpoenasHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports